export default "__VITE_ASSET__nlFwfjbv__"